import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import Loading from '../../components/Loading';

import AuthStore from '../../stores/AuthStore';
import RouterStore from '../../stores/RouterStore';

class Auth extends Component {
  async componentDidMount() {
    const { authStore, routerStore } = this.props;
    const {
      location: { search },
    } = routerStore;

    const uuid = new URLSearchParams(search).get('uuid');
    const linkUuid = new URLSearchParams(search).get('link.uuid');

    await authStore.toAuthenticate(uuid, linkUuid);
  }

  render() {
    const { authStore } = this.props;
    const { isLoading } = authStore;

    return <>{isLoading && <Loading />}</>;
  }
}

Auth.propTypes = {
  authStore: PropTypes.instanceOf(AuthStore).isRequired,
  routerStore: PropTypes.instanceOf(RouterStore).isRequired,
};

export default inject('authStore', 'routerStore')(observer(Auth));
